package util

import kotlinx.serialization.json.Json

val json = Json {
    encodeDefaults = false
}